import type { PackageId } from "@/lib/stripe";

/**
 * Partner codes (operator, 11.10.2026). A couple who books the Complete
 * package with a partner's code pays €25 less; the partner earns €50 once the
 * booking is fully paid and the 14-day withdrawal period is over. Other
 * packages have no partner discount: Essential's margin is too small.
 *
 * Client-safe: no database access here (see src/lib/supabase/referrals.ts).
 * The code itself is never stored on the visitor's device: it comes from the
 * link (?code=) or is typed at checkout, so no consent is needed (TDDDG § 25).
 */
export const REFERRAL_DISCOUNT_CENTS = 2500;
export const REFERRAL_COMMISSION_CENTS = 5000;
/** The commission is due once the withdrawal period is over (and the case is fully paid). */
export const REFERRAL_WITHDRAWAL_DAYS = 14;

export function referralAppliesTo(pkg: PackageId | string): boolean {
  return pkg === "complete";
}

/** Uppercase, without spaces; null when it cannot be a code. */
export function normalizeReferralCode(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const code = raw.trim().toUpperCase().replace(/\s+/g, "");
  return /^[A-Z0-9-]{3,20}$/.test(code) ? code : null;
}

/** First day the commission may be paid out (booking + 14 days). */
export function referralPayableFrom(bookedAt: string | Date): Date {
  const d = new Date(bookedAt);
  d.setDate(d.getDate() + REFERRAL_WITHDRAWAL_DAYS + 1);
  d.setHours(0, 0, 0, 0);
  return d;
}
